import React, { useState, useEffect } from "react";
import { Steps, Spin, Modal } from "antd";
import EmailVerify from "@/Verification/EmailVerify";
import PhoneVerify from "@/Verification/PhoneVerify";
function AccountVerification({
    closeWallet,
    otpParam,
    memberInfo,
    correctMemberInfo,
    accountVerificationType,
    GetThroughoutVerification,
}) {
    const [phoneVisible, setPhoneVisible] = useState(false); // 彈phone驗證框
    const [emailVisible, setEmailVisible] = useState(false); // 彈email驗證框
    const [isNext, setIsNext] = useState(false);
    const [phoneattemptRemaining, setPhoneAttemptRemaining] = useState(5); // sms剩餘次數
    const [emailattemptRemaining, setEmailAttemptRemaining] = useState(5); // 邮箱剩餘次數

    useEffect(() => {
        if (accountVerificationType === "All") {
            setEmailVisible(true);
            setIsNext(true);
        } else if (accountVerificationType === "Email") {
            setEmailVisible(true);
        } else if (accountVerificationType === "Phone") {
            setPhoneVisible(true);
        }
    }, [accountVerificationType]);
    const prams = {
        // 引用參數
        memberInfo: memberInfo && memberInfo,
        correctMemberInfo: correctMemberInfo,
        otpParam: otpParam, // withdrawal-otp
        times: 5,
        phoneattemptRemaining: phoneattemptRemaining,
        setPhoneAttemptRemaining: setPhoneAttemptRemaining,
        emailattemptRemaining: emailattemptRemaining,
        setEmailAttemptRemaining: setEmailAttemptRemaining,
        kindOfVerifications: "WithdrawalVerification",
        GetThroughoutVerification: GetThroughoutVerification,
    };

    const VerifyCategory = (
        otpVisible,
        emailVisible,
        phoneVisible,
    ) => {
        setEmailVisible(emailVisible);
        setPhoneVisible(phoneVisible);
    };

    return (
        <React.Fragment>
            {/* 第一步 邮箱验证 */}
            {emailVisible && (
                <EmailVerify
                    {...prams}
                    visible={emailVisible}
                    email={
                        memberInfo.isVerifiedEmail &&
                        memberInfo.isVerifiedEmail[0]
                    }
                    changeVerify={VerifyCategory}
                    closeModal={() => {
                        setEmailVisible(false);
                        closeWallet();
                    }}
                    onClose={() => {
                        setEmailVisible(false);
                    }}
                    isNext={isNext}
                    nextStep={() => {
                        setPhoneVisible(true);
                    }}
                    isAllowChange={true}
                />
            )}
            {/* 第二步 手机验证 */}
            {phoneVisible && (
                <PhoneVerify
                    {...prams}
                    visible={phoneVisible}
                    phone={
                        memberInfo.isVerifiedPhone &&
                        memberInfo.isVerifiedPhone[0]
                    }
                    changeVerify={VerifyCategory}
                    modalTitle={`ยืนยันข้อมูลเบอร์โทรศัพท์`} //手机验证
                    closeModal={() => {
                        setPhoneVisible(false);
                        closeWallet();
                    }}
                    onClose={() => {
                        setPhoneVisible(false);
                    }}
                    isAllowChange={true}
                />
            )}
        </React.Fragment>
    );
}

export default AccountVerification;
